// Menu.js

import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  useMediaQuery
} from "@mui/material";
import { useEffect } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import { useAuth } from "../AuthContext";
import { useNavigate } from "react-router-dom";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";

const drawerWidth = 220;

const Menu = () => {
const navigate = useNavigate();
const activeMenu = localStorage.getItem("activeMenu");
const handleLogout = async () => {
  await logout();
  navigate("/login");
};

const location = useLocation();

useEffect(() => {

  if (!location.pathname.toLowerCase().includes("declaration")) {
    localStorage.removeItem("activeMenu");
  }

}, [location.pathname]);
  const isMobile = useMediaQuery("(max-width:1024px)");

  const [mobileOpen, setMobileOpen] = useState(false);
  const { role, logout } = useAuth();

  const isActive = (path) => {

  const current = location.pathname.toLowerCase();

  if (path === "/") {
    return current === "/";
  }

  // toutes les pages déclarations
  if (path === "/Déclarations" || path === "/ListeDeclarations") {
    return current.includes("declaration");
  }

  return current.startsWith(path.toLowerCase());
};

  let menuItems = [];

if (role === "admin") {
  menuItems = [
    { label:"Accueil", path:"/" },
    { label:"Utilisateurs", path:"/utilisateurs" },
    { label:"Déclarations", path:"/ListeDeclarations" },
    { label:"Paie", path:"/Paie" },
    { label:"Documents", path:"/Documents" },
    { label:"Factures", path:"/FacturePage" }
  ];
}

if (role === "CDI") {
  menuItems = [
    { label:"Accueil", path:"/" },
    { label:"Déclarations", path:"/Déclarations" },
    { label:"Paie", path:"/Paie" },
    { label:"Documents", path:"/Documents" }
  ];
}

  const SidebarContent = (

    <Box
  sx={{
    p: 2,
    height: "100%",
    background: "linear-gradient(180deg, #0f172a 0%, #111827 55%, #020617 100%)",
    display: "flex",
    flexDirection: "column",
    borderRight: "1px solid rgba(255,255,255,0.06)",
    boxShadow: "12px 0 35px rgba(15,23,42,0.18)",
    overflowY: "auto"
  }}
>

      {/* LOGO */}
      <Box
  component={Link}
  to="/"
  sx={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    mb: 3,
    p: 1.3,
    borderRadius: 3,
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.08)",
    textDecoration: "none"
  }}
>
  <img
    src="/logo192.png"
    alt="Nova Portage"
    style={{
      width: "135px",
      maxHeight: "58px",
      objectFit: "contain"
    }}
  />
</Box>

      <List sx={{ flexGrow:1 }}>

        {menuItems.map((item)=>(
          <ListItemButton
  key={item.path}
  component={Link}
  to={item.path}

  selected={
  item.label === "Déclarations"
    ? activeMenu === "declarations" || isActive(item.path)
    : isActive(item.path)
}

  onClick={()=>setMobileOpen(false)}

  sx={{
  borderRadius: 2.5,
  mb: 1,
  px: 1.7,
  py: 1.25,
  color: "#cbd5e1",
  position: "relative",
  transition: "all .22s ease",

  "& .MuiListItemText-primary": {
    fontWeight: 700,
    fontSize: "0.86rem",
    color: "inherit"
  },

  "&.Mui-selected": {
    background: "linear-gradient(135deg, #1f6391 0%, #2563eb 100%)",
    color: "#ffffff",
    boxShadow: "0 12px 28px rgba(37,99,235,.28)",
    transform: "translateX(5px)"
  },

  "&.Mui-selected::before": {
    content: '""',
    position: "absolute",
    left: -8,
    top: "50%",
    transform: "translateY(-50%)",
    width: 4,
    height: "55%",
    borderRadius: 99,
    background: "#38bdf8"
  },

  "&:hover": {
    background: "rgba(37,99,235,.18)",
    color: "#ffffff",
    transform: "translateX(4px)"
  }
}}
>
  <ListItemText primary={item.label}/>
</ListItemButton>
        ))}

      </List>

<Box
  onClick={handleLogout}
  sx={{
  display: "flex",
  alignItems: "center",
  gap: 1,
  mt: 2,
  p: 1.4,
  borderRadius: 2.5,
  cursor: "pointer",
  background: "rgba(239,68,68,0.12)",
  color: "#fecaca",
  fontWeight: 800,
  justifyContent: "center",
  border: "1px solid rgba(248,113,113,0.22)",
  transition: "all .22s ease",

  "&:hover": {
    background: "#ef4444",
    color: "#ffffff",
    transform: "translateX(4px)",
    boxShadow: "0 12px 26px rgba(239,68,68,.25)"
  }
}}
>

<PowerSettingsNewIcon fontSize="small"/>

<Typography fontSize="0.85rem">
Déconnexion
</Typography>

</Box>
    </Box>

  );

  return (
    <>

      {isMobile && (

        <AppBar
          position="fixed"
          elevation={0}
          sx={{
  background: "rgba(15,23,42,0.95)",
  backdropFilter: "blur(14px)",
  borderBottom: "1px solid rgba(255,255,255,0.08)",
  boxShadow: "0 8px 28px rgba(15,23,42,0.18)"
}}
        >

          <Toolbar>

            <IconButton
              onClick={()=>setMobileOpen(true)}
              sx={{ color:"#ffffff" }}
            >
              <MenuIcon/>
            </IconButton>

            <Box
  component="img"
  src="/logo192.png"
  alt="Nova Portage"
  sx={{
    height: 34,
    ml: 1.5,
    objectFit: "contain"
  }}
/>

            

          </Toolbar>

        </AppBar>

      )}

      {!isMobile && (

        <Drawer
  variant="permanent"
  sx={{
    width: drawerWidth,
    flexShrink: 0,

    "& .MuiDrawer-paper": {
      width: drawerWidth,
      border: "none",
      background: "transparent",
      boxSizing: "border-box"
    }
  }}
>
          {SidebarContent}
        </Drawer>

      )}

      {isMobile && (

        <Drawer
  variant="temporary"
  open={mobileOpen}
  onClose={() => setMobileOpen(false)}

  sx={{
    "& .MuiDrawer-paper": {
      width: drawerWidth,
      background: "transparent",
      boxSizing: "border-box"
    }
  }}
>
          {SidebarContent}
        </Drawer>

      )}

    </>
  );
};

export default Menu;